import axios from 'axios'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { FaLongArrowAltRight } from 'react-icons/fa'
import { toast } from 'react-toastify'
import styles from "./Contact.module.css"
import { MenuItem, Select } from '@mui/material'

import { MdArrowRightAlt } from 'react-icons/md'

export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)
   
    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    return isIntersecting
}
function Contact() {
    const [error, setError] = useState('')
    const [isShow, setIshow] = useState(false)
    const ref = useRef()
    const isVisible1 = useOnScreen(ref)

    const setvalue = (e) => {
        setFormObj({ ...formObj, EnquiryTime: e.target.value })

    }

    const [formObj, setFormObj] = useState({
        name: "",
        email: "",
        number: "",
        EnquiryTime: "",
        company: ""
    })
    //console.log(formObj)
    const sendContactMail = async (e) => {
        if (formObj.email.length <= 0) {
            setError('Please enter a email address')
            toast.warn('Please enter a email address')
            return 
        }
        else{
            setError("")
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formObj.email)) {
            //console.log("please")
            const issue = !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formObj.email)
            //console.log(issue,"isseue")
            setError('Please enter a valid email')
            toast.warn('Please enter a valid email')
            return 
        }
        else{
            setError("")
        }
       
        e.preventDefault()
        axios({
            method: "post",
            url: "https://formspree.io/f/mzboynnq",
            data: {
                ...formObj
            }
        }).then(res => {
            setFormObj({ name: "", email: '', phone: '', message: "" })
            toast.success("Your mail is sent. We will contact you as soon as possible.")
            //console.log("Your mail is sent. We will contact you as soon as possible.")
            setFormObj({
                name: "",
                email: "",
                number: "",
                EnquiryTime: "",
                company: ""
            })
        }).catch(err => {
            toast.error('Something went wrong')
        })

    }
    return (
        <div id='contact' className={styles.Contact}>
            <div className={styles.aboutcontainer}>
                <div style={{ textAlign: "center" }}>
                    <h3 style={{ color: "#066263" }}>CONTACT</h3>
                </div>

                <div ref={ref} className={`${styles.info} ${isVisible1 ? styles.show1 : styles.hide1}`}>
                    <div className={`${styles.aboutInfocontainer}`}>
                        <div className={styles.workdGridItem}>
                            <p>会社名</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <input value={formObj.company} onChange={(e) => setFormObj({ ...formObj, company: e.target.value })} type="text" name="" id="" />
                        </div>
                        <div className={styles.workdGridItem}>
                            <p>担当者お名前</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <input value={formObj.name} onChange={(e) => setFormObj({ ...formObj, name: e.target.value })} type="text" name="" id="" />
                        </div>
                        <div className={styles.workdGridItem}>
                            <p>メールアドレス</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <input value={formObj.email} onChange={(e) => setFormObj({ ...formObj, email: e.target.value })} placeholder='xxx@sharvil-jp.com' type="email" name="" id="" />   
                            { error?.length>0&&<p style={{position:"absolute", color:"red", fontSize:"8px", left:"33%"}}>{error}</p>}                     </div>
                        <div className={styles.workdGridItem}>
                            <p>電話番号</p>
                        </div>
                        <div className={styles.workdGridItem}>
                            <input value={formObj.number} onChange={(e) => setFormObj({ ...formObj, number: e.target.value })} placeholder='003-0000-0000' type="number" name="" id="" />
                        </div>
                        <div className={styles.workdGridItem}>
                            <p>お問い合わせ内容</p>
                        </div>
                        <div className={`${styles.workdGridItem} `}>
                            {/* <div className={styles.listContainer}>
                                <div className={styles.clickable} onClick={() => setIshow(!isShow)}> {formObj.EnquiryTime}</div>
                                <div className={`${styles.list} ${isShow ? styles.showList : ""}`}>
                                    <p onClick={(e) => {setFormObj({ ...formObj, EnquiryTime: 'システム開発について' });setIshow(false);sendContactMail(e)}} value="システム開発について">システム開発について</p>
                                    <p onClick={(e) => {setFormObj({ ...formObj, EnquiryTime: '貿易について' });setIshow(false);sendContactMail(e)}} value="貿易について">貿易について</p>
                                    <p onClick={(e) => {setFormObj({ ...formObj, EnquiryTime: '事業開発について' });setIshow(false);sendContactMail(e)}} value="事業開発について">事業開発について</p>
                                    <p onClick={(e) => {setFormObj({ ...formObj, EnquiryTime: 'その他お問い合わせ' });setIshow(false);sendContactMail(e)}} value="その他お問い合わせ">その他お問い合わせ</p>
                                </div>
                            </div> */}

                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={formObj.EnquiryTime}
                                className={styles.selectValue}
                                onChange={setvalue}

                                sx={{
                                    "& fieldset": { border: "1px solid #066263", fontSize: "8px", }, height: "43px"
                                }}
                            >
                                <MenuItem value="システム開発について">システム開発について</MenuItem>
                                <MenuItem value="貿易について">貿易について</MenuItem>
                                <MenuItem value="事業開発について">事業開発について</MenuItem>
                                <MenuItem vvalue="その他お問い合わせ">その他お問い合わせ</MenuItem>
                            </Select>
                        </div>

                    </div>
                    <div className={styles.sendbutton}>
                        <button onClick={(e) => sendContactMail(e)}>送信する <MdArrowRightAlt /></button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Contact